// Generated by ReScript, PLEASE EDIT WITH CARE

import * as HomeTemplate from "../templates/HomeTemplate.re.mjs";
import * as WaitForMessages from "../shared/i18n/WaitForMessages.re.mjs";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactHelmetAsync from "react-helmet-async";
import * as RescriptRelay_Query from "rescript-relay/src/RescriptRelay_Query.re.mjs";
import * as HomePageQuery_graphql from "../../__generated__/HomePageQuery_graphql.re.mjs";
import Hero_posterJpg from "../molecules/home/hero_poster.jpg";

import { t } from '@lingui/macro'
;

let convertVariables = HomePageQuery_graphql.Internal.convertVariables;

let convertResponse = HomePageQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = HomePageQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, HomePageQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, HomePageQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(HomePageQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(HomePageQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(HomePageQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(HomePageQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let heroPoster = Hero_posterJpg;

function absoluteUrl(url) {
  if (url.startsWith("//")) {
    return "https:" + url;
  } else if (url.startsWith("/")) {
    return "https://www.instapainting.com" + url;
  } else {
    return url;
  }
}

function HomePage$Content(props) {
  let loader = ReactRouterDom.useLoaderData();
  let data = usePreloaded(loader.data);
  let titleString = t`Photo to Painting on Canvas | Instapainting`;
  let description = t`Turn your photo into a custom painting on canvas made by a professional artist. Oil, watercolor, charcoal, and pencil from real customer photos, starting at $89.`;
  let ogImage = absoluteUrl(heroPoster);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(ReactHelmetAsync.Helmet, {
        children: [
          JsxRuntime.jsx("title", {
            children: t`Photo to Painting on Canvas | Instapainting`
          }),
          JsxRuntime.jsx("meta", {
            content: description,
            name: "description"
          }),
          JsxRuntime.jsx("link", {
            href: "https://www.instapainting.com/",
            rel: "canonical"
          }),
          JsxRuntime.jsx("meta", {
            content: "website",
            property: "og:type"
          }),
          JsxRuntime.jsx("meta", {
            content: "https://www.instapainting.com/",
            property: "og:url"
          }),
          JsxRuntime.jsx("meta", {
            content: titleString,
            property: "og:title"
          }),
          JsxRuntime.jsx("meta", {
            content: description,
            property: "og:description"
          }),
          JsxRuntime.jsx("meta", {
            content: ogImage,
            property: "og:image"
          }),
          JsxRuntime.jsx("meta", {
            content: "summary_large_image",
            name: "twitter:card"
          })
        ]
      }),
      JsxRuntime.jsx(HomeTemplate.make, {
        query: data.fragmentRefs
      })
    ]
  });
}

let Content = {
  make: HomePage$Content
};

function HomePage(props) {
  return JsxRuntime.jsx(WaitForMessages.make, {
    children: () => JsxRuntime.jsx(HomePage$Content, {})
  });
}

let make = HomePage;

let $$default = HomePage;

export {
  Query,
  heroPoster,
  absoluteUrl,
  Content,
  make,
  $$default as default,
}
/*  Not a pure module */
